import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import App from "./App";

const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
  },
]);

console.info(`App Version: ${process.env.REACT_APP_VERSION}`);

const CHUNK_RELOAD_GUARD_KEY = "__meulance_chunk_reload_once__";

window.addEventListener("error", (event) => {
  const message = String((event as any)?.error?.message ?? event.message ?? "");
  const targetSrc = String((event as any)?.target?.src ?? "");
  const isChunkError =
    message.includes("ChunkLoadError") ||
    message.includes("Loading chunk") ||
    targetSrc.includes(".chunk.js");

  if (!isChunkError) return;
  if (sessionStorage.getItem(CHUNK_RELOAD_GUARD_KEY) === "1") return;

  sessionStorage.setItem(CHUNK_RELOAD_GUARD_KEY, "1");
  window.location.reload();
});

window.addEventListener("load", () => {
  sessionStorage.removeItem(CHUNK_RELOAD_GUARD_KEY);
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<RouterProvider router={router} />);
